import { Stack, styled } from '@mui/material'

export const BorderedStack = styled(Stack)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 8,
}))
